import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import cn from 'classnames';
import BN from 'bignumber.js';

import styles from '../../styles/main/main.module.scss';
import Tooltip from '../../../../../../components/tooltip';
import StakeMore from '../../../../../../components/Stake/stake-more';
import ZenUsdtIcon from '../../../../../../assets/images/ZENUSDT.svg';
import Header from '../../../../../../components/Stake/header';
import * as zenUsdtOmEthStakeActions from '../../../../../../actions/zenusdt-om-eth-stake-actions';
import { formatToken } from '../../../../../../helpers/token-helper';
import { ZENUSDT_OM_ETH } from '../../../../../../constants/blockchain-constants';
import { toPowerOfZen } from '../../../../../../blockchain/config';
import stakeBackground from '../../../../../../assets/stake/stake-more-zenusdt.svg';
import WithdrawCountdown from '../../../../../../components/withdraw-countdown';

const tooltipTextRewards = `
  Unclaimed Rewards are the Rewards that are earned through Staking.
  Unclaimed Rewards can either be Claimed and withdrawn into your wallet
  (after a 8 day unlocking period, or can be Re-Staked
  where they will start earning Rewards on immediately.`;

const tooltipTextWithdrawal = `
  Available OM for withdrawal includes both the OM that you are unstaking and the rewards you are claiming.
  Either of these two actions kick off an 8-day unlocking timer, after which the funds are available for withdrawal.
  Please note: if you are currently unstaking and decide to claim tokens half way through (or vice versa), the timer will
  be reset to 8-days, and you will be able to withdrawal both sets of tokens after 8-days.`;

const Main = () => {
  const dispatch = useDispatch();
  const dark = useSelector((state) => state.basic.dark);
  const { unstakedBalance, unstakedTime, rewardBalance, rewardEarned } = useSelector(
    (state) => state.ZENUSDTOMETHstake.stake,
  );

  const isDisabledWithdraw =
    unstakedTime > Date.now() / 1000 ||
    new BN(unstakedBalance).isLessThan(new BN(0.1).times(toPowerOfZen));

  return (
    <>
      <Header icon={ZenUsdtIcon} title='zenUSDT-Staking' />
      <div className={cn({ [styles.dark]: dark })}>
        <div className={styles.stakeMoreWrapper}>
          <StakeMore
            type={ZENUSDT_OM_ETH}
            title='Stake More'
            image={stakeBackground}
            onClick={() => dispatch(zenUsdtOmEthStakeActions.stakeSettings())}
          />
        </div>
        <div className={cn(styles.unstakeContainer, styles.uni)}>
          <Button
            className={styles.unstakeButton}
            onClick={() => dispatch(zenUsdtOmEthStakeActions.unstakeSettings())}
            variant='contained'
          >
            Unstake
          </Button>
          <Tooltip
            className={styles.unstakeTooltip}
            label='Unclaimed Rewards'
            text={tooltipTextRewards}
          />
          <div className={styles.unstakeControls}>
            <div className={styles.unstakeControlsText}>
              <div className={cn(styles.unstakeControlValue, styles.active)}>
                <span>
                  {formatToken(new BN(rewardEarned).plus(rewardBalance).toString(10), 10)} OM
                </span>
              </div>
            </div>
            <Button
              className={styles.secondaryButton}
              disabled={rewardBalance === '0' && rewardEarned === '0'}
              onClick={() => dispatch(zenUsdtOmEthStakeActions.claimRewardsDetails('unstake'))}
              variant='outlined'
            >
              Claim
            </Button>
          </div>
          <Tooltip
            className={styles.unstakeTooltip}
            label='Available OM for Withdrawal'
            text={tooltipTextWithdrawal}
          />
          <div className={styles.unstakeControls}>
            <div className={styles.unstakeControlsText}>
              <div className={cn(styles.unstakeControlValue, styles.active)}>
                <span>{formatToken(unstakedBalance, 10)} OM</span>
              </div>
              <div className={styles.unstakeControlDays}>
                <WithdrawCountdown
                  date={unstakedTime * 1000}
                  onDone={() => dispatch(zenUsdtOmEthStakeActions.getUntakedTime())}
                />
              </div>
            </div>
            <Button
              className={styles.secondaryButton}
              disabled={isDisabledWithdraw}
              onClick={() => dispatch(zenUsdtOmEthStakeActions.withdrawUnstakedDetails())}
              variant='outlined'
            >
              Withdraw
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;
